export const SET_QUESTION_BANK_ID = "SET_QUESTION_BANK_ID";
export const SET_QUESTION_BANK_NAME = "SET_QUESTION_BANK_NAME";


export const SET_QUESTION_BANK_TESTS_DATA = "SET_QUESTION_BANK_TESTS_DATA";

export const SET_QUESTION_BANK_TESTS_RESULT_DATA =
  "SET_QUESTION_BANK_TESTS_RESULT_DATA";
